import { get, readable, writable } from "svelte/store";
export class Form {
    constructor(id, name, description, disabled, status, bodyPartner, production, date_created, date_updated, date_disabled, sections) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.disabled = disabled;
        this.status = status;
        this.bodyPartner = bodyPartner;
        this.production = production;
        this.date_created = date_created;
        this.date_updated = date_updated;
        this.date_disabled = date_disabled;
        this.sectionsWritable = writable([]);
        this.sectionsReadable = readable([], set => this.sectionsWritable.subscribe(set));
        for (const section of sections) {
            this.addSection(section);
        }
    }
    get sections() {
        return [...get(this.sectionsWritable)];
    }
    addSection(section) {
        if (this.hasSectionId(section.id)) {
            return;
        }
        const sections = [...this.sections, section];
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    quitSection(sectionId) {
        if (!this.hasSectionId(sectionId)) {
            return;
        }
        const sections = this.sections.filter(({ id }) => id !== sectionId);
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    moveUp(section) {
        const { sections } = this;
        const index = sections.findIndex(({ id }) => id === section.id);
        if (index === 0) {
            return;
        }
        sections.splice(index, 1);
        sections.splice(index - 1, 0, section);
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    moveDown(section) {
        const { sections } = this;
        const index = sections.findIndex(({ id }) => id === section.id);
        if (index === sections.length - 1) {
            return;
        }
        sections.splice(index, 1);
        sections.splice(index + 1, 0, section);
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    toJSON() {
        const { id, name, sections, description, disabled, status, bodyPartner, production } = this;
        return { id, name, sections, description, disabled, status, bodyPartner, production };
    }
    hasSectionId(sectionId) {
        return this.sections.some(({ id }) => id === sectionId);
    }
    updateSectionsPositions(sections) {
        sections.forEach((section, index) => section.position.set(index));
    }
}
